import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import { CheckInActions } from 'src/app/features/check-in';
import { PackagesModule } from 'src/app/features/packages';
import { RootStoreState } from 'src/app/store';

import { AudioVideoCheckComponent } from '../../components/audio-video-component-check/audio-video-check.component';
import { SetIsOnAudioVideoPage } from 'src/app/features/audio-video-connection-monitor/store/actions/audio-video-connection-monitor.actions';
import { AudioVideoCheckStarted } from '../../store/actions/audio-video-check.actions';

@Component({
    selector: 'app-audio-video-check-page',
    imports: [PackagesModule, AudioVideoCheckComponent],
    styleUrl: './audio-video-check-page.component.scss',
    templateUrl: './audio-video-check-page.component.html'
})
export class AudioVideoCheckPageComponent implements OnDestroy {
  constructor(private readonly store: Store<RootStoreState.State>) {
    this.store.dispatch(
      SetIsOnAudioVideoPage({ payload: { isOnAudioVideoConfigurationPage: true } })
    );

    this.store.dispatch(AudioVideoCheckStarted());
  }

  ngOnDestroy(): void {
    this.store.dispatch(
      SetIsOnAudioVideoPage({ payload: { isOnAudioVideoConfigurationPage: false } })
    );
  }

  continueCheckIn(): void {
    this.store.dispatch(CheckInActions.ContinueCheckInOrRejoin());
  }
}
